import React from "react";

function Contact() {
   return (
      <div>
         <p></p>
         <p>Phone: 201-881-6804 | &nbsp;Email: patrick.ciongoli@gmail.com</p>
         <p>
            LinkedIn:
            <a href="https://www.linkedin.com/in/patrick-ciongoli-231a32165/">
               linkedin.com/in/patrick-ciongoli
            </a>
            | GitHub:
            <a href="https://github.com/pciongoli">github.com/pciongoli</a>
            &nbsp;
         </p>
      </div>
   );
}

export default Contact;
